webpackJsonp([230170946505588],{

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 2/4/18
	 */
	var FAQ = function FAQ(_ref) {
	    var question = _ref.question,
	        answer = _ref.answer;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'content faqbox',
	            style: { border: '1px solid #eaecee', padding: '2em 4em' } },
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'strong',
	                null,
	                question
	            ),
	            ' '
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            answer
	        )
	    );
	};
	
	FAQ.propTypes = {
	    question: _propTypes2.default.string,
	    answer: _propTypes2.default.string
	};
	
	exports.default = FAQ;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var HeroCTA = function HeroCTA(_ref) {
	    var heromain = _ref.heromain,
	        herosub = _ref.herosub,
	        herourl = _ref.herourl;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns is-centered' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section home-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'has-text-centered' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'has-text-weight-semibold is-size-2 has-text-centered' },
	                                    heromain
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'h5',
	                                { className: 'has-text-weight-semibold is-size-4 has-text-centered' },
	                                herosub
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'buttons is-centered' },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        className: 'button is-large is-primary',
	                                        href: herourl },
	                                    'Sign Up'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	HeroCTA.propTypes = {
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        heromain: _propTypes2.default.string,
	        herosub: _propTypes2.default.string,
	        herourl: _propTypes2.default.string
	    }))
	};
	
	exports.default = HeroCTA;
	module.exports = exports['default'];

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contactPageQuery = exports.FAQPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _FAQ = __webpack_require__(169);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _NavBar = __webpack_require__(14);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _HeroCTA = __webpack_require__(77);
	
	var _HeroCTA2 = _interopRequireDefault(_HeroCTA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 2/4/18
	 */
	var FAQPageTemplate = exports.FAQPageTemplate = function FAQPageTemplate(_ref) {
	    var title = _ref.title,
	        subtitle = _ref.subtitle,
	        meta_title = _ref.meta_title,
	        meta_description = _ref.meta_description,
	        faqs = _ref.faqs,
	        heromain = _ref.heromain,
	        herosub = _ref.herosub,
	        herourl = _ref.herourl;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                meta_title
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: meta_description })
	        ),
	        _react2.default.createElement(_NavBar2.default, null),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-primary is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'column is-10 is-offset-1' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'section' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'title' },
	                                    title
	                                ),
	                                _react2.default.createElement(
	                                    'h2',
	                                    { className: 'subtitle' },
	                                    subtitle
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                faqs.map(function (faq, id) {
	                    return _react2.default.createElement(_FAQ2.default, { key: id, question: faq.question, answer: faq.answer });
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(_HeroCTA2.default, { heromain: heromain,
	                herosub: herosub,
	                herourl: herourl })
	        )
	    );
	};
	
	FAQPageTemplate.propTypes = {
	    title: _propTypes2.default.string,
	    subtitle: _propTypes2.default.string,
	    meta_title: _propTypes2.default.string,
	    meta_description: _propTypes2.default.string,
	    faqs: _propTypes2.default.array,
	    heromain: _propTypes2.default.string,
	    herosub: _propTypes2.default.string,
	    herourl: _propTypes2.default.string
	
	};
	
	var FAQPage = function FAQPage(_ref2) {
	    var data = _ref2.data;
	    var frontmatter = data.markdownRemark.frontmatter;
	
	    return _react2.default.createElement(FAQPageTemplate, {
	        title: frontmatter.title,
	        subtitle: frontmatter.subtitle,
	        meta_title: frontmatter.meta_title,
	        meta_description: frontmatter.meta_description,
	        faqs: frontmatter.faqs,
	        heromain: frontmatter.heromain,
	        herosub: frontmatter.herosub,
	        herourl: frontmatter.herourl
	    });
	};
	FAQPage.propTypes = {
	    data: _propTypes2.default.shape({
	        markdownRemark: _propTypes2.default.shape({
	            frontmatter: _propTypes2.default.object
	        })
	    })
	};
	
	exports.default = FAQPage;
	var contactPageQuery = exports.contactPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-faq-page-js-976398be480258765a79.js